import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import Routes from '../Routes';

function App() {
  return (
    <div className="App">
      <Routes />
    </div>
  );
}

export default App;
